import { useEffect, useRef } from 'react';

type Props = {
	isOpen: boolean;
	onClose: () => void;
	shouldManuallyCloseOnOutsideClick: boolean;
};

const CLICK_LISTENER_TYPE = 'mousedown';
export const useManuallyCloseOnOutsideClick = ({
	isOpen,
	onClose,
	shouldManuallyCloseOnOutsideClick,
}: Props) => {
	const dialogContentRef = useRef<HTMLDivElement>(null);
	const triggerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (shouldManuallyCloseOnOutsideClick) {
			let listener: undefined | ((event: Event) => void);

			if (isOpen) {
				listener = ({ target }: Event) => {
					if (
						target instanceof Node &&
						!dialogContentRef.current?.contains(target) &&
						!triggerRef.current?.contains(target)
					) {
						onClose();
					}
				};
				window.addEventListener(CLICK_LISTENER_TYPE, listener);
			}

			return () => {
				listener && window.removeEventListener(CLICK_LISTENER_TYPE, listener);
			};
		}
		return undefined;
	}, [onClose, isOpen, shouldManuallyCloseOnOutsideClick]);

	return { dialogContentRef, triggerRef };
};
